import { ProviderParametersFragment } from '../../../generated/graphql'
import { PrimaryHourlyEnergyFlow } from '../../HourlyEnergyFlow'
import { HourlyVariables, Provider } from './Provider'

export type MultiTypeHourlyVariables = HourlyVariables & {
  remainingDemands: PrimaryHourlyEnergyFlow[]
}

/**
 * Base provider class for providers that provide for multiple energy types.
 */
export abstract class MultiTypeProvider<
  TParameters extends ProviderParametersFragment = ProviderParametersFragment,
  THourlyVariables extends MultiTypeHourlyVariables = MultiTypeHourlyVariables,
> extends Provider<TParameters, THourlyVariables> {
  /**
   * Providers may implement this to add their own hourly variables.
   */
  protected getHourlyVariables(
    hour: number,
    demands: PrimaryHourlyEnergyFlow[],
  ): THourlyVariables {
    return {
      remainingDemands: demands,
      outdoorTemperature: this.temperatureValues?.[hour],
    } as THourlyVariables
  }
}
